











import Vue from 'vue';

type Option = {
  value: string | number;
  label: string;
};

interface Props {
  value: string | number;
  selectOptions: Option[];
  multiple: boolean;
  placeholder: string;
}

interface Data {
  selected: string | number;
  options: Props['selectOptions'];
}

interface Methods {
  updateSelect: (selected: Data['selected']) => void;
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    value: {},
    selectOptions: {},
    multiple: {},
    placeholder: {}
  },
  data () {
    return {
      selected: this.value,
      options: this.selectOptions
    };
  },
  watch: {
    selectOptions: function () {
      this.options = this.selectOptions;
    }
  },
  methods: {
    updateSelect: function (selected) {
      this.$emit('input', selected);
    }
  }
});

